import { Stack } from "@bookingcom/bui-react";
import React, { useMemo } from "react";
import { UIFlightData } from "@flights/types";
import FareCard from "../../../../components/elements/FlightCard/components/FareCard";
import { SkeletonFlightCard } from "../../../../components/elements/Skeleton/SkeletonFlightCard";
import { convertFlightToFare } from "../utils";
import { useI18n } from "@bookingcom/lingojs-react";
import useBrandedFares from "../../../hooks/useBrandedFares";
import Frame from "../../../../components/elements/Frame";
import useTrackFirstFarePriceMismatch from "../../../hooks/useTrackFirstFarePriceMismatch";

type Props = {
  flight: UIFlightData;
};

const FareSelector = ({ flight }: Props) => {
  const i18n = useI18n();
  const { fetchStatus, brandedFareOffers } = useBrandedFares(flight.token);
  const hasBrandedFareOffers = !!brandedFareOffers && brandedFareOffers.length > 0;

  const hasSellableBag = useMemo(
    () =>
      brandedFareOffers &&
      brandedFareOffers.some((fare) =>
        fare?.brandedFareInfo?.sellableFeatures?.some((feature) => feature.category === "BAGGAGE")
      ),
    [brandedFareOffers]
  );

  useTrackFirstFarePriceMismatch(flight, brandedFareOffers);

  return (
    <Frame ml={4} mr={4} mb={4}>
      <Stack gap={1}>
        {hasBrandedFareOffers ? (
          brandedFareOffers.map((brandedFareOffer, i) => (
            <FareCard
              key={brandedFareOffer.token}
              index={i}
              fareOffer={brandedFareOffer}
              baseOffer={flight}
              fetchStatus={fetchStatus}
              hasSellableBag={hasSellableBag}
            />
          ))
        ) : (
          <>
            <FareCard fareOffer={convertFlightToFare(flight, i18n)} baseOffer={flight} fetchStatus={fetchStatus} />
            {fetchStatus === "loading" && <SkeletonFlightCard />}
          </>
        )}
      </Stack>
    </Frame>
  );
};

export default FareSelector;
